import { jsx as i } from "react/jsx-runtime";
let a = !1, n = !1, u = !1;
const r = {
  mousedown: c,
  keydown: d,
  touchstart: f
};
function s() {
  Object.keys(r).forEach((t) => {
    document.removeEventListener(t, r[t]);
  });
}
function e(t) {
  document.addEventListener(t, r[t]);
}
function c() {
  if (!a && !u) {
    a = !0, n = !1;
    const t = document.querySelector("html");
    t == null || t.setAttribute("data-mousenavigation", "true"), t == null || t.removeAttribute("data-touchnavigation"), s(), e("touchstart"), e("keydown");
  }
}
function d(t) {
  if (t.key === "Tab") {
    const o = document.querySelector("html");
    s(), o == null || o.removeAttribute("data-mousenavigation"), o == null || o.removeAttribute("data-touchnavigation"), a = !1, n = !1, e("touchstart"), e("mousedown");
  }
}
function f() {
  if (!n) {
    a = !1, n = !0;
    const t = document.querySelector("html");
    t == null || t.setAttribute("data-touchnavigation", "true"), t == null || t.removeAttribute("data-mousenavigation"), s(), e("touchstart"), e("keydown"), e("mousedown");
  }
  u = !0, setTimeout(() => {
    u = !1;
  }, 150);
}
function v() {
  typeof document < "u" && (e("touchstart"), e("mousedown"));
}
v();
const m = ({ brand: t, children: o }) => /* @__PURE__ */ i("div", { "data-testid": "core-entry", className: t, children: o });
export {
  m as C
};
